import styles from "../styles/components/Image.module.css";

function Image() {
  return (
    <div className={styles.Image}>
      <h1>Explore the world around you</h1>
      <p>Travel the globe through ecological trips.</p>
    </div>
  );
}

export default Image;
